import script from "./SimpleTextarea.vue?vue&type=script&lang=ts&setup=true"
export * from "./SimpleTextarea.vue?vue&type=script&lang=ts&setup=true"

import "./SimpleTextarea.vue?vue&type=style&index=0&id=afd23424&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afd23424"]])

export default __exports__